export default __webpack_public_path__ + "static/521-b130d70d650327856439ee5644fada63.gif";